module.exports = "/assets/site/images/pdf_icon.png?4dd6b9eee043eb6a26dde2f181756140";